export interface IVideoItemSchema {
  mediaType: EMediaType;
  videoUrl: string;
}

export interface IImageItemSchema {
  fullUrl: string;
  isPrimaryImage?: boolean | null;
  mediaType: EMediaType;
  thumbnailUrl: string;
  galleryThumbnailUrl: string;
  alt?: string;
}

export type TMediaItemSchema = IVideoItemSchema | IImageItemSchema;

export enum EMediaType {
  Image = 'image',
  Video = 'video',
}

export interface ICarouselProps {
  media: TMediaItemSchema[];
  padding?: number;
  defaultAlt?: string;
  onSliderInit(): void;
}

export interface ICarouselState {
  isAnimated: boolean;
  isFullScreen: boolean;
  isMouseMoved: boolean;
  showElementId: number;
  currentElementId: number;
}
